import { useAuth } from '@/contexts/AuthContext';
import { cn } from '@/lib/utils';
import { FileCheck, FileText, LayoutDashboard, Settings, Upload, Users } from 'lucide-react';
import { NavLink, useLocation } from 'react-router-dom';

interface NavItem {
  title: string;
  href: string;
  icon: React.ComponentType<{ className?: string }>;
}

const userNavItems: NavItem[] = [
  { title: 'Dashboard', href: '/dashboard', icon: LayoutDashboard },
  { title: 'Documents', href: '/documents', icon: FileText },
  { title: 'Tax Filings', href: '/tax-filings', icon: FileCheck },
  { title: 'Upload', href: '/upload', icon: Upload },
  { title: 'Settings', href: '/settings', icon: Settings },
];

const adminNavItems: NavItem[] = [
  { title: 'Dashboard', href: '/admin', icon: LayoutDashboard },
  { title: 'Users', href: '/admin/users', icon: Users },
  // { title: 'Documents', href: '/admin/documents', icon: FileText },
  { title: 'Settings', href: '/settings', icon: Settings },
];

export function MobileNav() {
  const { isAdmin } = useAuth();
  const location = useLocation();
  
  const navItems = isAdmin() ? adminNavItems : userNavItems;

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 border-t bg-background md:hidden">
      <div className="flex h-16 items-center justify-around px-2">
        {navItems.map((item) => {
          const isActive = location.pathname === item.href || 
            (item.href !== '/admin' && item.href !== '/dashboard' && item.href !== '/settings' && location.pathname.startsWith(item.href));
          
          return (
            <NavLink
              key={item.href}
              to={item.href}
              className={cn(
                "flex flex-col items-center justify-center gap-1 px-3 py-2 text-xs transition-colors min-w-[64px]",
                isActive 
                  ? "text-primary" 
                  : "text-muted-foreground hover:text-foreground"
              )}
            >
              <item.icon className={cn("h-5 w-5", isActive && "text-primary")} />
              <span className="truncate">{item.title}</span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
